import script from "./PlanningView.vue?vue&type=script&setup=true&lang=js"
export * from "./PlanningView.vue?vue&type=script&setup=true&lang=js"

import "./PlanningView.vue?vue&type=style&index=0&id=4b2c81ce&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4b2c81ce"]])

export default __exports__